import { render } from "./DataManage.vue?vue&type=template&id=f92fbbc4&scoped=true"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"

import "./DataManage.vue?vue&type=style&index=0&id=f92fbbc4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92fbbc4"]])

export default __exports__